export default __webpack_public_path__ + "static/media/airdrop.5c5ea52b.png";